<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1996 6.11777H11.1708C7.90537 6.11777 5.25781 8.76503 5.25781 12.0306V21.692C5.25781 24.9575 7.90537 27.6048 11.1708 27.6048C14.1359 27.6048 17.8657 27.6048 20.8321 27.6048C24.0975 27.6048 26.745 24.9575 26.745 21.692V12.0306C26.745 8.76503 24.0975 6.11777 20.8321 6.11777H19.8019V5.21619C19.8019 4.75589 19.4283 4.38216 18.9679 4.38216C18.5075 4.38216 18.1339 4.75589 18.1339 5.21619V6.11777H13.8676V5.21619C13.8676 4.75589 13.494 4.38216 13.0336 4.38216C12.5732 4.38216 12.1996 4.75589 12.1996 5.21619V6.11777ZM25.077 14.5291V21.692C25.077 24.0362 23.1754 25.9367 20.8321 25.9367C17.8657 25.9367 14.1359 25.9367 11.1708 25.9367C8.82614 25.9367 6.92587 24.0362 6.92587 21.692V14.5291H25.077ZM12.1996 7.78583H11.1708C8.82614 7.78583 6.92587 9.68628 6.92587 12.0306V12.8611H25.077V12.0306C25.077 9.68628 23.1754 7.78583 20.8321 7.78583H19.8019V8.6874C19.8019 9.14771 19.4283 9.52143 18.9679 9.52143C18.5075 9.52143 18.1339 9.14771 18.1339 8.6874V7.78583H13.8676V8.6874C13.8676 9.14771 13.494 9.52143 13.0336 9.52143C12.5732 9.52143 12.1996 9.14771 12.1996 8.6874V7.78583Z"
      fill="#111E25"
    />
  </svg>
</template>

<script>
export default {
  name: 'Appointment'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
